import {
  DashboardSalesIcon,
  ReportsManagerIcon,
  ReportsOrdersIcon,
  ReportsSalesIcon,
} from '../components/icons/analytics';

export const analyticsMenuItems = () => [
  {
    title: 'Dashboards',
    items: [
      {
        title: 'Sales',
        link: '/analytics/dashboards/sales',
        icon: <DashboardSalesIcon />,
      },
    ],
  },
  {
    title: 'Reports',
    items: [
      {
        title: 'Reports Manager',
        icon: <ReportsManagerIcon />,
        link: '/analytics/reports',
      },
      {
        title: 'Sales',
        icon: <ReportsSalesIcon />,
        items: [
          {
            title: 'Sales by channel',
            link: '/analytics/reports/sales',
          },
          {
            title: 'Sales by product',
            link: '/analytics/reports/sales-by-product',
          },
          {
            title: 'Sales by warehouse',
            link: '/analytics/reports/sales-by-warehouse',
          },
        ],
      },
      {
        title: 'Orders',
        icon: <ReportsOrdersIcon />,
        items: [
          {
            title: 'Returns',
            link: '/analytics/reports/returns',
          },
          {
            title: 'Return Notifications',
            link: '/analytics/reports/return-notifications',
          },
          {
            title: 'Cancellations',
            link: '/analytics/reports/cancellations',
          },
        ],
      },
    ],
  },
];
